import { Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import "./dailyCoTable.css";

const columns = [
    {
        title: "Room",
        dataIndex: "room",
        key: "room",
        fixed: "left",
    },
    {
        title: "Session Id",
        dataIndex: "session_id",
        key: "session_id",
        fixed: "left",
        sorter: () => {},
    },
    {
        title: "Start Time",
        dataIndex: "start_time",
        key: "start_time",
        sorter: () => {},
    },
    {
        title: "Duration",
        dataIndex: "duration",
        key: "duration",
        sorter: () => {},
    },
    {
        title: "First Participant Start Time",
        dataIndex: "first_participant_start_time",
        key: "first_participant_start_time",
        sorter: () => {},
    },
    {
        title: "First Participant Duration",
        dataIndex: "first_participant_duration",
        key: "first_participant_duration",
        sorter: () => {},
    },
    {
        title: "Second Participant Start Time",
        dataIndex: "second_participant_start_time",
        key: "second_participant_start_time",
        sorter: () => {},
    },
    {
        title: "Second Participant Duration",
        dataIndex: "second_participant_duration",
        key: "second_participant_duration",
        sorter: () => {},
    },
];

function DailyCoTable() {
    const [dailyCoData, setDailyCoData] = useState();
    const { hotel_id } = useParams();
    const { selectedDates } = useContext(SettingContext);
    const [formData, setFormData] = useState({
        hotel_id,
        page: 0,
        limit: 10,
    });
    const [totalRecords, setTotalRecords] = useState(0);

    const {
        status: callsDataStatus,
        data: callDataRes,
        refetch: fetchCallData,
    } = useQuery(
        "dynatraceCalls",
        async () => {
            return await HTTP("/dashboard/getHotelDailyCoData", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchCallData();
    }, []);

    useEffect(() => {
        fetchCallData();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (callsDataStatus === "success") {
            const { data: hotelDailyCoData, total } = callDataRes;
            setTotalRecords(total);
            setDailyCoData(hotelDailyCoData);
        }
    }, [callsDataStatus, callDataRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            {!dailyCoData ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={dailyCoData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="session_id"
                    className="dashboard-table"
                    isScroll
                />
            )}
        </Card>
    );
}

export { DailyCoTable };
